import {
  MarketplacePreviewAffiliationsParams,
  MarketplacePreviewStoresParams,
} from '../requests'
import { MarketplacePreviewItemsParams } from './useMarketplacePreviewItems'
import { MarketplaceAccessMode } from '../types'

export const MARKETPLACE_PREVIEW_QUERY_KEYS = {
  items: (
    mode: MarketplaceAccessMode,
    params: MarketplacePreviewItemsParams
  ) => ['marketplaceAccessItems', mode, params],
  stores: (
    mode: MarketplaceAccessMode,
    params: MarketplacePreviewStoresParams
  ) => ['marketplaceAccessStores', mode, params],
  store: (mode: MarketplaceAccessMode, providerId: number) => [
    'marketplaceAccessStore',
    mode,
    providerId,
  ],
  affiliations: (
    mode: MarketplaceAccessMode,
    params: MarketplacePreviewAffiliationsParams
  ) => ['marketplaceAccessAffiliations', mode, params],
} as const
